

import { ScrollArea } from '@/components/ui/scroll-area';
import { Card, CardContent } from '@/components/ui/card';

const CookiePolicy = () => {
  return (
    <section id="cookies" className="mb-16">
      <h2 className="text-2xl font-bold mb-6 pb-2 border-b border-neutral-200 text-left">Cookie Policy</h2>
      
      <Card className="border shadow-sm">
        <CardContent className="p-0">
          <ScrollArea className="h-[400px] rounded-md">
            <div className="p-6 text-left">
              <p className="text-neutral-600 mb-4">
                This Cookie Policy explains how Team Jumo, Inc. ("we," "our," or "us") uses cookies and similar technologies on our website and mobile app ("The Mat Monster").
                By using The Mat Monster, you agree to the use of cookies as described in this policy. You can manage your cookie preferences in your browser or device settings.
              </p>

              <h3 className="text-xl font-semibold mt-6 mb-3">1. What Are Cookies?</h3>
              <p className="text-neutral-600 mb-6">
                Cookies are small text files placed on your device when you use a website or app. They help remember your preferences, analyze traffic, and support functionality.
                We may also use similar technologies such as pixels, web beacons, or local storage.
              </p>

              <h3 className="text-xl font-semibold mt-6 mb-3">2. Types of Cookies We Use</h3>
              <div className="overflow-x-auto mb-6">
                <table className="min-w-full bg-white border border-neutral-200">
                  <thead>
                    <tr>
                      <th className="py-2 px-4 border-b text-left">Type</th>
                      <th className="py-2 px-4 border-b text-left">Purpose</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="py-2 px-4 border-b">Essential Cookies</td>
                      <td className="py-2 px-4 border-b">Needed for core app functionality (e.g., keeping you logged in).</td>
                    </tr>
                    <tr>
                      <td className="py-2 px-4 border-b">Performance Cookies</td>
                      <td className="py-2 px-4 border-b">Help us understand how users interact with the app (e.g., analytics).</td>
                    </tr>
                    <tr>
                      <td className="py-2 px-4 border-b">Preference Cookies</td>
                      <td className="py-2 px-4 border-b">Remember settings or preferences (e.g., dark mode, technique filters).</td>
                    </tr>
                    <tr>
                      <td className="py-2 px-4 border-b">Marketing Cookies</td>
                      <td className="py-2 px-4 border-b">May be used in the future to deliver personalized content or promotions.</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p className="text-neutral-600 mb-6">
                We do not use cookies for advertising or third-party sales of your information.
              </p>

              <h3 className="text-xl font-semibold mt-6 mb-3">3. Third-Party Cookies</h3>
              <p className="text-neutral-600 mb-2">Some cookies may be placed by third-party services we use, such as:</p>
              <ul className="list-disc pl-6 mb-4 text-neutral-600">
                <li>Analytics platforms (e.g., Google Analytics)</li>
                <li>Payment processors</li>
                <li>Performance and error tracking tools</li>
              </ul>
              <p className="text-neutral-600 mb-6">
                These providers may have their own cookie policies, which we encourage you to review.
              </p>

              <h3 className="text-xl font-semibold mt-6 mb-3">4. How to Control Cookies</h3>
              <p className="text-neutral-600 mb-2">Most browsers let you control or delete cookies through settings:</p>
              <ul className="list-disc pl-6 mb-4 text-neutral-600">
                <li>Clear stored cookies</li>
                <li>Block specific types</li>
                <li>Receive alerts before cookies are placed</li>
              </ul>
              <p className="text-neutral-600 mb-6">
                On mobile devices, you can manage app-specific permissions or reset identifiers in your settings.
              </p>

              <h3 className="text-xl font-semibold mt-6 mb-3">5. Changes to This Cookie Policy</h3>
              <p className="text-neutral-600 mb-6">
                We may update this Cookie Policy to reflect changes in our technology or legal requirements. We'll notify you of significant changes within the app or on our website.
              </p>

              <h3 className="text-xl font-semibold mt-6 mb-3">6. Contact Us</h3>
              <p className="text-neutral-600 mb-2">For questions or concerns, contact:</p>
              <p className="text-neutral-600 mb-2">The Mat Monster</p>
              <p className="text-neutral-600 mb-2">Email: oss@thematmonster.com</p>
              <p className="text-neutral-600 mb-6">Mailing Address: 500 E Whitestone BLVD Unit 902 Cedar Park, TX 78630</p>
            </div>
          </ScrollArea>
        </CardContent>
      </Card>
    </section>
  );
};

export default CookiePolicy;
